module.exports = __webpack_public_path__ + "img/LandmaschMech-AH-101-131.e89b97b2.jpg";